// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { TrackingModel } from "../base/tracking-model";

export class TextSubscription extends TrackingModel {
	public TextSubscriptionId: number = 0;
	public Name: string = "";
	public Description?: string;
	public PhoneNumber: string = "";
	public LastStartedOnUTC?: Date;
	public LastStoppedOnUTC?: Date;
}